import type { ProjectPLBucket } from '../types';

/**
 * Suggest a P&L bucket from a change-order line description.
 *
 * Action words win over the material they mention, so "Installation of 2x6 T&G"
 * is Install and "Extra design + Stamp" is Engineering. Unrecognized text stays
 * Unassigned so a person picks the category instead of silently landing in Timber.
 */
const CHANGE_ORDER_LINE_BUCKET_RULES: Array<{ match: RegExp; bucket: ProjectPLBucket }> = [
  { match: /\b(install|installation|labor|labour|crew|crane|telehandler)\b/i, bucket: 'install' },
  { match: /\b(stamp|engineering|engineer|structural)\b/i, bucket: 'engineering' },
  { match: /\b(design|drafting|architect)\b/i, bucket: 'design' },
  { match: /\b(freight|shipping|delivery|trucking)\b/i, bucket: 'freight' },
  { match: /\b(travel|hotel|lodging|per\s?diem|airfare|mileage)\b/i, bucket: 'travel' },
  { match: /\b(cnc|fabrication|fabricat|shop)\b/i, bucket: 'production' },
  {
    match: /\b(timber|lumber|wood|material|materials|decking|t\s*&\s*g|spruce|oak|pine|steel|anchors?|fasteners?|hardware|consumables?|epoxy)\b/i,
    bucket: 'timber',
  },
];

export function suggestChangeOrderLineBucket(description: string): ProjectPLBucket {
  const text = description.trim();
  if (!text) return 'unassigned';
  for (const rule of CHANGE_ORDER_LINE_BUCKET_RULES) {
    if (rule.match.test(text)) return rule.bucket;
  }
  return 'unassigned';
}
